<template>
  <div class="forecast-item">
    <div id="item-container" v-for="(item,index) in items" :key="index">
      <div :class="item" :style="items.length===(index+1)?'':style"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForecastItem',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      style: 'margin-bottom: 6px'
    }
  }
}
</script>

<style lang="stylus" scoped>
.forecast-item
  width 100%
  height 100%
  #item-container
    display flex
    justify-content center
    align-items center
  .itemOne, .itemTwo
    width 100%
    height 4.9px
  .itemOne
    background #000
  .itemTwo
    box-sizing border-box
    background #fff
    border-left 28px solid #000
    border-right 28px solid #000
</style>
